import React from 'react'
import { get } from 'lodash'

export default class Group extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    let render = false
    const oldState = get(this.props, 'state')
    const newState = get(nextProps, 'state')
    const lob = get(nextProps, 'lob')
    const oldMoment = get(this.props, 'moment')
    const newMoment = get(nextProps, 'moment')
    const oldRange = get(this.props, 'range')
    const newRange = get(nextProps, 'range')
    const oldSearch = get(this.props, 'search')
    const newSearch = get(nextProps, 'search')
    if (newState !== null) {
      if (oldMoment !== newMoment) render = true
      if (oldRange !== newRange) render = true
      if (oldSearch !== newSearch) render = true
      Object.keys(newState).map(key => {
        if (key === lob) {
          const oldValue = oldState ? oldState[key] : null
          const newValue = newState ? newState[key] : null
          if (oldValue !== newValue) render = true
        }
        return key
      })
    } else render = true
    return render
  }
  render() {
    return (
      this.props.renderGroup()
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/metrolendar/group.js